#import "../fragments/product-fragment.graphql"

query GetProducts($first: Int, $after: String, $categoryId: ID, $archived: Boolean) {
    products(first: $first, after: $after, categoryId: $categoryId, archived: $archived) {
        edges {
            node {
                ...ProductFragment
            }
        }
        pageInfo {
            hasNextPage
            endCursor
        }
    }
}
